/**
 * useEscClose composable
 * @param callback - Function to call when Escape is pressed
 * @param isActive - Optional function returning boolean, determines if Escape should trigger callback
 */
export function useEscClose(callback: () => void, isActive: () => boolean = () => true) {
  function handleEscKey(event: KeyboardEvent) {
    if (event.key === 'Escape' && isActive()) {
      callback();
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleEscKey);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleEscKey);
  });
}
